module.exports = __webpack_public_path__ + "static/media/pic7.b1353080.png";